import { provideAppInitializer, inject, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { CoreModule } from './core/core.module';
import { AppInitService } from './app-init.service';
import { ConfirmationPopupWithoutSpinnerComponent } from './shared/component/confirmation-popup-without-spinner/confirmation-popup-without-spinner.component';
import { ConfirmationPopupWithInputComponent } from './shared/component/confirmation-popup-with-input/confirmation-popup-with-input.component';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './router/custom-router-reuse-strategy';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmationPopupWithoutSpinnerComponent,
    ConfirmationPopupWithInputComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    AuthModule,
    AppRoutingModule,
    DashboardModule
    
  ],
  providers: [
    AppInitService,
    provideAppInitializer(() => {
      const appInitService = inject(AppInitService);
      return appInitService.loadConfiguration();
    }),
    provideAppInitializer(() => {
      const appInitService = inject(AppInitService);
      return appInitService.loadLabels();
    }),
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
